<template>
  <div>
    <div v-for="(faq, index) in compLost" :key="index" class="faq">
      <div v-on:click="changeOpen(index)" class="faq-question">
        <div class="icon-wrapper">
          <img
            :class="{ openImg: faq.open }"
            src="@/assets/newImges/Chevron.svg"
            alt="open faq icon"
          />
        </div>
        <span>{{ getT(faq.question) }}</span>
      </div>
      <div v-if="faq.open" class="faq-answer">
        <div class="ul" v-html="getT(faq.answer)"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "aboutWhy",
  data() {
    return {
      list: [
        {
          question: "about.list.question1",
          answer: "about.list.reason1Q1",
          open: false
        },
        {
          question: "about.list.question2",
          answer: "about.list.reason1Q2",
          open: false
        },
        {
          question: "about.list.question3",
          answer: "about.list.reason1Q3",
          open: false
        },
        {
          question: "about.list.question4",
          answer: "about.list.reason1Q4",
          open: false
        },
        {
          question: "about.list.question5",
          answer: "about.list.reason1Q5",
          open: false
        },
        {
          question: "about.list.question6",
          answer: "about.list.reason1Q6",
          open: false
        }
      ]
    };
  },
  computed: {
    listData: function() {
      return [
        {
          question: this.$t("about.list.question1"),
          answer: this.$t("about.list.reason1Q1"),
          open: false
        },
        {
          question: this.$t("about.list.question2"),
          answer: this.$t("about.list.reason1Q2"),
          open: false
        },
        {
          question: this.$t("about.list.question3"),
          answer: this.$t("about.list.reason1Q3"),
          open: false
        },
        {
          question: this.$t("about.list.question4"),
          answer: this.$t("about.list.reason1Q4"),
          open: false
        },
        {
          question: this.$t("about.list.question5"),
          answer: this.$t("about.list.reason1Q5"),
          open: false
        },
        {
          question: this.$t("about.list.question6"),
          answer: this.$t("about.list.reason1Q6"),
          open: false
        }
      ];
    },
    compLost: {
      get: function() {
        return this.list;
      },
      set: function() {
        console.log("set");
        this.list = new Array(...this.list);
      }
    }
  },
  methods: {
    changeOpen(x) {
      console.log(this.list[x].open);
      this.list[x].open = !this.list[x].open;
      console.log(this.list[x].open + " " + this.list[x].question);
    },
    getT(str) {
      return this.$t(str);
    }
  }
};
</script>

<style lang="scss" scoped>
.faq {
  font-family: Outfit;
  min-height: 104px;
  border: 2px solid $gray-blue-700;
  border-radius: 10px;
  margin-bottom: 30px;
  background-color: $gray-blue-100;

  .faq-question {
    font-weight: 400;
    font-style: Regular;
    font-size: 25px;
    line-height: 100%;
    letter-spacing: 0%;

    color: $blue-1000;
    height: 104px;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0 24px;

    .icon-wrapper {
      height: 56px !important;
      img {
        transition: 0.3s;
      }
      .openImg {
        transform: rotate(90deg);
      }
    }
  }
  .faq-answer {
    font-weight: 400;
    font-style: Regular;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0%;
    color: $blue-400;

    margin-bottom: 30px;
    padding-left: 80px;
    padding-right: 10px;
  }
  .ul {
    margin: 0;
    padding: 0;
    .line {
      display: inline-block;
      text-decoration: underline !important;
      text-decoration-line: underline;
      color: red;
    }
  }
  .ul li {
    padding: 1.4% 0;
    margin-left: 0;
  }
}
@media only screen and (max-width: 768px) {
  .faq {
    min-height: 70px;
    margin-bottom: 20px;
    .faq-question {
      font-size: 20px;
      text-align: left;
      height: 70px;
      padding: 0 16px 0 0;

      .icon-wrapper {
        .minus-icon {
          margin-bottom: 5px;
        }
      }
    }
    .faq-answer {
      font-size: 16px;
      line-height: 24px;

      margin-bottom: 30px;
      padding-left: 56px;
    }
  }
}
@media only screen and (max-width: 430px) {
  .faq {
    // padding-bottom: 15px;
    min-height: 50px;
    .faq-question {
      height: 50px;
      cursor: pointer;
      font-size: 18px;

      .icon-wrapper {
        .minus-icon {
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>
